import React, { Component } from "react";
import Box from "@mui/material/Box";
import Sidebar from "./Sidebar";
import { Divider, Paper, Typography,LinearProgress, Backdrop, CircularProgress } from "@mui/material";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Grid from '@mui/material/Grid';
import CountUp from "react-countup";
import Diversity3Icon from '@mui/icons-material/Diversity3';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import GroupsIcon from '@mui/icons-material/Groups';
import Appbar from '../../src/admin_panel_crm/Appbar'
import base from '../base.json'

const drawerWidth = 80;
export class Dashboard extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      tab : 'one',
      is_loader_open : false,


/////// counters ///
               total_job_count : 0,






    
    }
  }
 



async componentDidMount(){
  
            let  m =  await sessionStorage.getItem("data")
    let  ll = JSON.parse(m)
fetch(`${base.base_url}/property_portal/vendor_portal/builder/totalPropertyCounts`, {
      headers:{
    'content-type':'application/json',
   // 'Access-Control-Allow-Origin': 'http://localhost:3000',
      },
          method: "post",
          body:JSON.stringify({
            id: ll[0].builder_id
          })
        }).then(function(response) {
          return response.json();
        })
        .then((data)=> {
         this.setState({
                total_job_count : data.counts,
         
         })
        });

      
      
}






  render() {


    return (
  <Box>
    <Appbar/>
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box
          sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
        >
<Box sx={{height:'100%',width:'100%'}}>

{
  /// header data
}
<Box  sx={{height:47,width:'100%',backgroundColor:'#fff',borderRadius:0,mt:0.2,borderBottom:0.5,borderBottomColor:'#dddddd'}}>
<Tabs
  value={this.state.tab}
  onChange={this.handleChange}
  aria-label="wrapped label tabs example"
>
  <Tab
    value="one"
    sx={{textTransform:'none',fontWeight:'500',fontSize:15}}
    label="Dashboard"
    wrapped
  />
</Tabs>
</Box>



{
  /// grid container
}
<Box sx={{paddingLeft:3,paddingRight:3,paddingTop:2,display:this.state.is_loader_open?'none':'block'}}>

<Box>
<Grid container spacing={1}>
  <Grid size={{xs:12,sm:6,md:2.4}}>

    <Paper sx={{width:'100%',height:110, background: 'linear-gradient(to right bottom, #430089, #ff9f43)'}}>
      <Box sx={{padding:1.5}}>
        <Typography sx={{fontSize:12,fontWeight:'550',fontFamily:'sans-serif',color:'#fff'}}>TOTAL PROPERTY COUNTS</Typography>
         <Typography sx={{fontSize:20,fontWeight:'550',fontFamily:'sans-serif',color:'#fff',mt:0.5}}> <CountUp start={0} end={this.state.total_job_count}  /></Typography>
         <Box sx={{width:'100%',height:40,display:'flex',justifyContent:'right'}}>
         <Box sx={{height:40,width:40,backgroundColor:'#fff0d3',borderRadius:3,display:'flex',justifyContent:'center',alignItems:'center',mb:5}}>
        <Diversity3Icon sx={{height:35,width:35,color:'#ffb621'}}/>
       </Box>
     </Box>
    </Box>
    </Paper>

  </Grid>
 
</Grid>
</Box>



{
  //// group division 
}

<Box sx={{mt:2,mb:2,display:'none'}}>

<Grid container spacing={3}>

<Grid size={{xs:12,sm:12,md:8}}>
<Box sx={{height:600,width:'100%',backgroundColor:'pink'}}>




</Box>
</Grid>
<Grid size={{xs:12,sm:12,md:4}}>
<Box sx={{height:600,width:'100%',backgroundColor:'red'}}>




</Box>
</Grid>

</Grid>


</Box>



































</Box>
</Box>

        </Box>




<Backdrop
  sx={(theme) => ({ color: '#fff',backgroundColor:'transparent',  zIndex: theme.zIndex.drawer + 1})}
  open={this.state.is_loader_open}
  onClick={this.handleClose}
>
<CircularProgress sx={{color:"#008ffb"}} />
</Backdrop>



      </Box>
   </Box>
    );
  }
}

export default Dashboard;
